import { Routes } from '@angular/router';

export const PIPELINE_ROUTES: Routes = [
  { path: ':pipelineId/opportunities/:opportunityId', loadComponent: () => import('../opportunities/components/opportunity-view/opportunity-view.component').then(m => m.OpportunityViewComponent) },
  {
    path: ':id', loadComponent: () => import('./components/pipeline-view/pipeline-view.component').then(m => m.PipelineViewComponent), children: [
      { path: 'opportunities', loadComponent: () => import('./components/pipeline-view/pipeline-opportunities/pipeline-opportunities.component').then(m => m.PipelineOpportunitiesComponent) },
      { path: 'tasks', loadComponent: () => import('./components/pipeline-view/pipeline-tasks/pipeline-tasks.component').then(m => m.PipelineTasksComponent) },
      { path: '', loadComponent: () => import('./components/pipeline-view/pipeline-overview/pipeline-overview.component').then(m => m.PipelineOverviewComponent) }
    ]
  },
  { path: '', loadComponent: () => import('./components/pipeline-list/pipeline-list.component').then(m => m.PipelineListComponent) }
];
